export function stringify(value) {
    return JSON.stringify(value);
}
export function parse(string, defaultValue) {
    try {
        return JSON.parse(string);
    }
    catch (error) {
        if (defaultValue === undefined) {
            throw error;
        }
        return defaultValue;
    }
}
//# sourceMappingURL=json.js.map